"use client";
import * as React from "react";
import { cn } from "@/lib/utils";

export interface SimpleTab {
  value: string;
  label: string;
  icon?: React.ComponentType<{ className?: string }>;
  count?: number;
}

export interface SimpleTabsProps {
  value: string;
  onValueChange: (v: string) => void;
  tabs: SimpleTab[];
  tabsListClassName?: string;
  className?: string;
}

export function SimpleTabs({ value, onValueChange, tabs, tabsListClassName, className }: SimpleTabsProps) {
  return (
    <div role="tablist" aria-orientation="horizontal" className={cn("flex items-center gap-1 border-b border-border overflow-x-auto omega-sidebar-scroll", tabsListClassName, className)}>
      {tabs.map(t => {
        const Icon = t.icon;
        const active = value === t.value;
        return (
          <button
            key={t.value}
            role="tab"
            aria-selected={active}
            data-state={active ? "active" : "inactive"}
            onClick={() => onValueChange(t.value)}
            className={cn(
              "relative inline-flex items-center gap-1.5 whitespace-nowrap px-3 py-2 text-sm font-medium transition-colors outline-none",
              active
                ? "text-foreground"
                : "text-muted-foreground hover:text-foreground"
            )}
          >
            {Icon && <Icon className="size-4" />}
            <span>{t.label}</span>
            {typeof t.count === "number" && (
              <span className={cn("ml-1 inline-flex items-center justify-center rounded-full px-1.5 py-0.5 text-[10px] font-semibold",
                active ? "bg-primary text-primary-foreground" : "bg-muted text-muted-foreground")}>
                {t.count}
              </span>
            )}
            {active && <span className="absolute inset-x-0 -bottom-px h-0.5 bg-primary" />}
          </button>
        );
      })}
    </div>
  );
}
